module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Scissors-41a87bf3ece24ddb0bfa0baefa6a755d.svg";